import {Action} from "@ngrx/store";

export const LOAD_WEBSITE_TAGS: string = '[info] Load Website Tags';
export const LOAD_WEBSITE_TAGS_SUCCESS: string = '[info] Load Website Tags Success';
export const LOAD_WEBSITE_TAGS_FAIL: string = '[info] Load Website Tags Fail';

export class LoadWebsiteTags implements Action {
  readonly type: string = LOAD_WEBSITE_TAGS;
  constructor() {}
}

export class LoadWebsiteTagsSuccess implements Action {

  readonly type: string = LOAD_WEBSITE_TAGS_SUCCESS;
  constructor(public payload: {}) {}

}

export class LoadWebsiteTagsFail implements Action {

  readonly type: string = LOAD_WEBSITE_TAGS_FAIL;
  constructor(public payload: string) {}

}


export type WebsiteTagsAction = LoadWebsiteTags | LoadWebsiteTagsSuccess | LoadWebsiteTagsFail;
